/**
 * @copyright Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 */

import React from "react";

import { Col, Row } from "react-bootstrap";

import { CompanyDetailText } from "../Company";
import { APP_COLORS } from "../../../common/Constants";

import SpendFormatNumber from "./SpendFormatNumber";

import styled from "styled-components";

const SpendSection = (props) => {
    const { company } = props;

    return (
        <MainContainer>
            <Row>
                <Col xs={4} md={4} lg={4} xl={4}>
                    <div style={{textAlign: 'center', paddingTop: 15}}>
                        <CompanyDetailText fontWeight={'bold'} fontSize={20} color={APP_COLORS['green']}>
                            ${SpendFormatNumber(Math.ceil((company.activity?.categorySpend | 0) / 1000) * 1000)}
                        </CompanyDetailText>
                        <CompanyDetailText fontSize={16}>Total Spend</CompanyDetailText>
                    </div>
                </Col>
                <Col xs={4} md={4} lg={4} xl={4}>
                    <div style={{textAlign: 'center', paddingTop: 15}}>
                        <CompanyDetailText fontWeight={'bold'} fontSize={20}>{company.activity?.jobStarts | 0}</CompanyDetailText>
                        <CompanyDetailText fontSize={16}>Total Jobs</CompanyDetailText>
                    </div>
                </Col>
                <Col xs={4} md={4} lg={4} xl={4}>
                    <div style={{textAlign: 'center', paddingTop: 15}}>
                        <CompanyDetailText fontWeight={'bold'} fontSize={20}
                               color={APP_COLORS['orange']}>{company.activity?.activeJobStarts | 0}</CompanyDetailText>
                        <CompanyDetailText fontSize={16}>Active Jobs</CompanyDetailText>
                    </div>
                </Col>
            </Row>
        </MainContainer>
    )
}

export default SpendSection;

const MainContainer = styled.div`
    margin-top: 20px;
    margin-bottom: 30px;
`;
